import { FormattedMessage } from 'react-intl';

import { MainBlock as ImageModalMainBlock } from 'components/organisms/ImageModal/MainBlock/MainBlock';

export const MainBlock = () => (
    <ImageModalMainBlock>
        <FormattedMessage id="onboarding_modal.body" />
    </ImageModalMainBlock>
);
